var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"footer_wrap"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":"https://upload.vwingist.com/melscn/0image/2025/04/4992487787254717356.png","alt":""}})])]),_c('div',{staticClass:"footer-copy flex-rowc"},[_c('p',[_vm._v("- VESCOR ©‌ 2025 -")])])])
}]

export { render, staticRenderFns }